module.exports = __webpack_public_path__ + "static/media/art-from-light.355b31f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/art-from-light.png
// module id = 188
// module chunks = 0